/**
 * Mock-LMS banner. Required on every teacher route per S1-011 acceptance.
 *
 * Uses `role="status"` + `aria-live="polite"` so screen readers announce
 * the mock state without interrupting other actions, and `data-testid` so
 * E2E tests can assert it deterministically.
 */

export interface BannerProps {
  /** Optional override; defaults to the standard mock-LMS copy. */
  message?: string;
}

export const MOCK_LMS_BANNER_TEXT =
  'Mock LMS — no real data. Real Canvas connection is disabled in local MVP.';

export function Banner({ message = MOCK_LMS_BANNER_TEXT }: BannerProps) {
  return (
    <div
      className="mock-banner"
      role="status"
      aria-live="polite"
      data-testid="mock-lms-banner"
    >
      <span className="mock-banner__dot" aria-hidden="true" />
      <span>{message}</span>
    </div>
  );
}
